import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetTestingProgramsTestingProgramIdTestingControlsSuspense } from "api/generated/testing-programs/testing-programs";

export const TESTING_CONTROLS_QUERY_KEY = "testing-controls";
export function useTestingProgramTestingControlsQuery(
    testingProgramId: number
) {
    return useGetTestingProgramsTestingProgramIdTestingControlsSuspense(
        testingProgramId,
        {
            query: {
                queryKey: [TESTING_CONTROLS_QUERY_KEY, testingProgramId],
                select: (response) => response.data,
                refetchOnMount: true,
                refetchOnWindowFocus: true,
                staleTime: STALE_TIME_RESOURCES,
            },
        }
    );
}
